export default __webpack_public_path__ + "static/media/AuthForm.e8e7400a.png";